import { Button, Form, Input } from 'antd';
import React, { useRef } from 'react';
import { useNashr } from './State';

function Add() {
    const formRef = useRef();
    let { addNashr } = useNashr()
    
    const handleFinish = (values) => {
        addNashr(values);
        formRef.current?.resetFields();
    }
    
    return (
        <Form
            ref={formRef}
            labelCol={{
                span: 24,
            }}
            wrapperCol={{
                span: 24,
            }}
            onFinish={handleFinish}
            autoComplete="off"
        >
            <Form.Item label="Nashriyot nomi" name={'nashriyot'}>
                <Input />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" type="primary">Saqlash</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;